import { Component, OnInit, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { Observable } from 'rxjs';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { startWith, map } from 'rxjs/operators';
import { MatChipInputEvent } from '@angular/material/chips';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { User } from 'src/app/auth/user.model';

@Component({
    selector: 'app-add-reference',
    templateUrl: './add-reference.component.html',
    styleUrls: ['./add-reference.component.scss'],
    standalone: false
})
export class AddReferenceComponent implements OnInit {
  reference: any;
  addReferenceForm: FormGroup;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  departmentCtrl = new FormControl();
  filteredDepartments: Observable<string[]>;
  departments: any[];
  allDepartments: any[];
  @ViewChild('departmentInput') departmentInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  departmentsList: any[];
  invalidDepartments: boolean;
  type: any;
  allowContacted: any;
  productId: any;
  isLoading = false;
  user: User;

  constructor(public dialogRef: MatDialogRef<AddReferenceComponent>,
              private dataService: DataService,
              private utils: UtilsService,
              private router: Router,
              private authService: AuthService,
              private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) {
                this.productId = router.routerState.snapshot.root.children[0].children[0].params.id;
                this.invalidDepartments  = false;
                this.user = this.authService.getUserData();
                this.type = data.type;
                this.departments = new Array<string>();
                this.allDepartments = new Array<string>();
                this.reference = this.data.reference;
                if (this.type === 'Edit') {
                  this.getReference();
                }
                this.filteredDepartments = this.departmentCtrl.valueChanges.pipe(
                  startWith(null),
                  map((department: string | null) => department ? this._filter(department) : this.allDepartments.slice()));
              }

  ngOnInit(): void {
    this.addReferenceForm = new FormGroup({
      name: new FormControl(this.reference ? this.reference.name : null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      department: new FormControl(this.reference ? this.reference.department : null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      contactName: new FormControl(this.reference ? this.reference.contactName : null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      email: new FormControl(null, [Validators.required, Validators.email, this.utils.isValidEmail.bind(this)]),
      phone: new FormControl(this.reference ? this.reference.phone : null, [Validators.required,
        Validators.minLength(7), Validators.maxLength(14)]),
      country_code: new FormControl(this.reference ? this.reference.contactCountryCode : null, [Validators.required, Validators.maxLength(5)]),
      qoute: new FormControl(this.reference ? this.reference.qoute : null, null),
      allowContacted: new FormControl(false, null),
    });

    this.getAllDepartments()
  }

  getAllDepartments() {
    this.isLoading = true;
    this.dataService.get('department/RetrieveDepartmentsByName?searchKeyword=' + '&ProductId=' + this.productId, true).then((data) => {
      if (data.statusCode === 200) {
        this.departmentsList = [];
        this.allDepartments = [];
        this.departmentsList = data.data.records;
        this.departmentsList.forEach((productData) => {
          this.allDepartments.push(productData);
        });
        this.filteredDepartments = this.departmentCtrl.valueChanges.pipe(
          startWith(null),
          map((product: string | null) => product ? this._filter(product) : this.allDepartments.slice()));
      }
      this.isLoading = false;
      });
  }

  getReference() {
    this.dataService.get('product/references/RetrieveReferenceById/' + this.productId + '/' + this.reference.id).then((data) => {
      if (data.statusCode === 200) {
        this.reference = data.data;
        if (this.reference.departmetns) {
          this.reference.departmetns.forEach(element => {
            this.departments.push(element);
          });
        }
        this.addReferenceForm.controls.name.setValue(this.reference.instituteName);
        this.addReferenceForm.controls.department.setValue(this.reference.instituteDepartment);
        this.addReferenceForm.controls.contactName.setValue(this.reference.contactName);
        this.addReferenceForm.controls.email.setValue(this.reference.contactEmail);
        this.addReferenceForm.controls.phone.setValue(this.reference.contactPhone);
        this.addReferenceForm.controls.country_code.setValue(this.reference.contactCountryCode);
        this.addReferenceForm.controls.qoute.setValue(this.reference.quote);
        this.addReferenceForm.controls.allowContacted.setValue(this.reference.allowedToBeConnected);
      }
    });
  }

  closeDialog() {
    if (this.addReferenceForm.dirty && this.type === 'Add') {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Warning',
          type: 'Warn',
          message: 'You will miss your information once you close',
          buttonText: 'cancel',
          numberOfButtons: 2,
          seconButtonText: 'Ok'
        }
      });
      dialogRef.afterClosed().subscribe((status) => {
        if (status === 'Ok') {
          this.dialog.closeAll();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

  private _filter(value: any): any[] {
    return this.allDepartments.filter(department => department.name.toLowerCase().includes(value));
  }

  allowContactedToggle(event: any) {
    this.allowContacted = event;
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      if (this.departments.includes(value.trim())) {
        this.departments.push({
          id: Math.random(),
          name: value.trim()
        });

        this.invalidDepartments = false;
      }
    }

    if (input) {
      input.value = '';
    }

    this.departmentCtrl.setValue(null);
  }

  remove(department: any, index: any): void {
    if (index >= 0) {
      this.departments.splice(index, 1);
      if (this.departments.length > 0) {
        this.invalidDepartments = false;
      } else {
        this.invalidDepartments = true;
      }
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    let departmentExist = false;
    for (let index = 0; index < this.departments.length; index++) {
      const element = this.departments[index];
      if (element.id === event.option.value.id) {
        departmentExist = true;
      }
    }
    if (!departmentExist) {
      this.departments.push(event.option.value);
    }
    this.departmentInput.nativeElement.value = '';
    this.departmentCtrl.setValue(null);

    if (this.departments.length > 0) {
      this.invalidDepartments = false;
    } else {
      this.invalidDepartments = true;
    }
  }

  searchDepartment(event: any) {
    if (this.departmentInput.nativeElement.value === "") {
      this.departmentsList = [];
      this.allDepartments = [];
      this.filteredDepartments = this.departmentCtrl.valueChanges.pipe(
        startWith(null),
        map((department: string | null) => department ? this._filter(department) : this.allDepartments.slice()));
    } else {
    this.isLoading = true;
    this.dataService.get('department/RetrieveDepartmentsByName?searchKeyword=' +
    this.departmentInput.nativeElement.value + '&ProductId=' + this.productId, true).then((data) => {
        if (data.statusCode === 200) {
          this.departmentsList = [];
          this.allDepartments = [];
          this.departmentsList = data.data.records;
          this.departmentsList.forEach((departmentData) => {
            this.allDepartments.push(departmentData);
          });
        }
        this.filteredDepartments = this.departmentCtrl.valueChanges.pipe(
          startWith(null),
          map((department: string | null) => department ? this._filter(department) : this.allDepartments.slice()));
        this.isLoading = false;
      });
    }
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onSubmit() {
    if (this.departments.length > 0) {
    } else {
      this.invalidDepartments = true;
      this.addReferenceForm.markAllAsTouched();
      return;
    }

    const departmentsIds = [];
    for (let index = 0; index < this.departments.length; index++) {
      const element = this.departments[index];
      departmentsIds.push(element.id);
    }

    if (this.addReferenceForm.valid) {
      if (this.type === 'Edit') {
        const payload = {
          productId: parseInt(this.productId.toString(), 10),
          referenceId: parseInt(this.reference.id.toString(), 10),
          InstituteName: this.addReferenceForm.get('name')?.value,
          InstituteDepartment: this.addReferenceForm.get('department')?.value,
          ContactName: this.addReferenceForm.get('contactName')?.value,
          ContactEmail: this.addReferenceForm.get('email')?.value,
          ContactPhone: (this.addReferenceForm.get('phone')?.value || '').replace(/\s+/g, ''),
          CountryCode: this.addReferenceForm.get('country_code')?.value,
          Quote: this.addReferenceForm.get('qoute')?.value,
          allowedToBeConnected: this.addReferenceForm.get('allowContacted')?.value,
          Departments: departmentsIds,
        };
        this.dataService.put('product/references/UpdateReference', payload).then((data) => {
          if (data.statusCode === 200) {
            this.dialogRef.close(payload);
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Success',
                type: 'Success',
                message: 'Reference information updated successfully',
                buttonText: 'Ok'
              }
            });
          } else {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Something went wrong, Please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
      } else if (this.type === 'Add') {
        const payload = {
          productId: parseInt(this.productId.toString(), 10),
          InstituteName: this.addReferenceForm.get('name')?.value,
          InstituteDepartment: this.addReferenceForm.get('department')?.value,
          ContactName: this.addReferenceForm.get('contactName')?.value,
          ContactEmail: this.addReferenceForm.get('email')?.value,
          ContactPhone: (this.addReferenceForm.get('phone')?.value || '').replace(/\s+/g, ''),
          CountryCode: this.addReferenceForm.get('country_code')?.value,
          Quote: this.addReferenceForm.get('qoute')?.value,
          allowedToBeConnected: this.addReferenceForm.get('allowContacted')?.value,
          departments: departmentsIds,
        };
        this.dataService.post('product/references/CreateReference', payload).then((data) => {
          if (data.statusCode === 200) {
            this.dialogRef.close({id: data.data.id, instituteName: payload.InstituteName,
              instituteDepartment: payload.InstituteDepartment});
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Success',
                type: 'Success',
                message: 'Reference added successfully',
                buttonText: 'Ok'
              }
            });
          } else if (data.statusCode === 613) {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Invalid phone format!',
                buttonText: 'Ok'
              }
            });
          } else {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Something went wrong, Please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
      }
    } else {
      this.addReferenceForm.markAllAsTouched();
    }

  }

}
